import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';
import { initialMutations } from '.';

interface FeedbackState {
  single?: {
    business_oid: string;
    rating: number;
    message: string;
  };
  popup: boolean;
}

const state: FeedbackState = {
  single: undefined,
  popup: false,
};

const getters: GetterTree<FeedbackState, RootState> = {};

const actions: ActionTree<FeedbackState, RootState> = {
  create(_, { object_id, payload }) {
    return http.v1.fb.create(object_id, payload);
  },
};

const mutations: MutationTree<FeedbackState> = {
  ...initialMutations,
};

const feedback: Module<FeedbackState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default feedback;
